import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import _taggedTemplateLiteralLoose from '@babel/runtime/helpers/esm/taggedTemplateLiteralLoose';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormActions, spaceMixin, Button, Paragraph, Spacer, Form, Flex, FormField, Label, Input, Collapsible, TextButton } from '@zillow/constellation';
import { FormHelpError } from '@zillow/reg-login-components';

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n    width: 100% !important;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    margin-top: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var StyledFormActions = styled(FormActions)(_templateObject(), spaceMixin('md'));
var StyledButton = styled(Button)(_templateObject2());

var ZmaConsent = function ZmaConsent(_ref) {
  var initialFirstName = _ref.initialFirstName,
      initialLastName = _ref.initialLastName,
      _ref$zmaHandlerFns = _ref.zmaHandlerFns,
      zmaHandlerFns = _ref$zmaHandlerFns === void 0 ? {} : _ref$zmaHandlerFns;
  var setZMAConsent = zmaHandlerFns.setZMAConsent;

  var _useState = useState(initialFirstName),
      _useState2 = _slicedToArray(_useState, 2),
      firstName = _useState2[0],
      setFirstName = _useState2[1];

  var _useState3 = useState(initialLastName),
      _useState4 = _slicedToArray(_useState3, 2),
      lastName = _useState4[0],
      setLastName = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      errorText = _useState6[0],
      setErrorText = _useState6[1];

  var handleSubmit = function handleSubmit() {
    // Reset error text when we submit
    setErrorText('');
    var zmaHandlerResponse = setZMAConsent({
      firstName: firstName,
      lastName: lastName
    }); // We expect a promise back that we can catch any errors on, if we got something else back just show the error

    if (zmaHandlerResponse && zmaHandlerResponse.catch && typeof zmaHandlerResponse.catch === 'function') {
      zmaHandlerResponse.catch(function (error) {
        if (error && error.message) {
          setErrorText(error.message);
        } else {
          setErrorText('There was an issue. Please try again.');
        }
      });
    } else {
      setErrorText('There was an issue. Please try again.');
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Paragraph, null, "Enter your full name to automatically view Zestimate Market Analysis on the homes you search or receive notifications when a home's Zestimate Market Analysis becomes available."), /*#__PURE__*/React.createElement(Spacer, {
    marginTop: "md"
  }, /*#__PURE__*/React.createElement(Form, {
    marginTop: "xs",
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      handleSubmit();
    }
  }, /*#__PURE__*/React.createElement(Flex, {
    display: "flex",
    alignItems: "center",
    marginBottom: "xs"
  }, /*#__PURE__*/React.createElement(Flex, {
    flexGrow: 1,
    order: 2
  }, /*#__PURE__*/React.createElement(FormField, {
    fluid: true
  }, /*#__PURE__*/React.createElement(Label, {
    htmlFor: "firstName"
  }, "First name"), /*#__PURE__*/React.createElement(Input, {
    id: "firstName",
    placeholder: "Enter first name",
    onChange: function onChange(e) {
      return setFirstName(e.target.value);
    },
    defaultValue: firstName,
    required: true
  }))), /*#__PURE__*/React.createElement(Flex, {
    flexGrow: 1,
    order: 2,
    marginLeft: "xs"
  }, /*#__PURE__*/React.createElement(FormField, {
    fluid: true
  }, /*#__PURE__*/React.createElement(Label, {
    htmlFor: "lastName"
  }, "Last name"), /*#__PURE__*/React.createElement(Input, {
    id: "lastName",
    placeholder: "Enter last name",
    onChange: function onChange(e) {
      return setLastName(e.target.value);
    },
    defaultValue: lastName,
    required: true
  })))), /*#__PURE__*/React.createElement(Collapsible, null, function (shown, toggle) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, shown ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Paragraph, {
      fontType: "bodySmall"
    }, "By registering for or using Zestimate Market Analysis (\"ZMA\"), in any manner, you acknowledge and agree that: (i) you are entering into a lawful customer-broker relationship with Zillow, Inc. (\"Zillow\" or \"us\"), or similar non-client and non-agency relationship (as defined by applicable state or provincial/territorial law), however, in no event is Zillow representing you as your agent in a real estate transaction; (ii) you have a bona fide interest in the purchase, sale, or lease of real estate; (iii) you will only use the information from ZMA for your personal, non-commercial use, except in connection with your consideration of the purchase and sale of an individual property; (iv) you will not copy, redistribute, or retransmit any of the data or information provided through ZMA except in connection with your consideration of the purchase and sale of an individual property; and (v) you waive any right or expectation to a physical inspection of the interior or exterior of the real estate that is the subject of the ZMA, except where such inspection cannot be waived by law. You also acknowledge the MLS's ownership of, and the validity of the MLS's copyright in, the MLS database compilation."), /*#__PURE__*/React.createElement(Paragraph, {
      fontType: "bodySmall",
      paddingTop: "xs"
    }, "You further acknowledge that you are not a party to an exclusive representation agreement with another brokerage, and that if you are, you are hereby specifically directing us to provide ZMA herein with the consent or knowledge of your representative. It is not Zillow's intent to solicit the offering of any licensed real estate agent or to interfere with any existing agency relationship you may have.")) : /*#__PURE__*/React.createElement(Paragraph, {
      fontType: "bodySmall"
    }, "By registering for or using Zestimate Market Analysis (\"ZMA\"), in any manner, you acknowledge and agree that: (i) you are"), /*#__PURE__*/React.createElement(TextButton, {
      fontType: "bodySmall",
      onClick: function onClick(e) {
        e.preventDefault();
        toggle();
      },
      type: "button"
    }, shown ? 'See less' : 'See more'));
  }), /*#__PURE__*/React.createElement(StyledFormActions, null, /*#__PURE__*/React.createElement(StyledButton, {
    buttonType: "primary",
    type: "submit"
  }, "Submit")), errorText && /*#__PURE__*/React.createElement(FormHelpError, {
    text: errorText
  }))));
};

ZmaConsent.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Handler for submitting name for ZMA consent
   */
  zmaHandlerFns: PropTypes.shape({
    getZMAConsent: PropTypes.func,
    setZMAConsent: PropTypes.func
  }).isRequired,

  /**
   * First name to prepopulate the field
   */
  initialFirstName: PropTypes.string,

  /**
   * Last name to prepopulate the field
   */
  initialLastName: PropTypes.string
} : {};
ZmaConsent.defaultProps = {
  initialFirstName: '',
  initialLastName: ''
};

export { ZmaConsent };
